<div class="modal-header modal-header border-2 h5 modal-header pb-2 pt-2 text-bg-warning">
  Recover documents
  <button type="button" class="btn btn-outline-dark btn-sm px-2 py-1" (click)="activeModal.dismiss()" title="Close">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="pb-0 ps-4 pt-0">
  <div *ngIf="clientName && clientName !== ''">
    <strong>Client:</strong>
    {{ clientName }}
  </div>
  <div *ngIf="casDescription && casDescription !== ''">
    <strong>Case:</strong>
    {{ casDescription }}
  </div>
</div>

<div class="modal-body pt-2">
  <div class="tx-table">
    <header class="grid">
      <div class="g-col-5">Document name</div>
      <div class="g-col-4">Date</div>
      <div class="g-col-3">Last modified by</div>
    </header>
    <div
      *ngFor="let a of autosaves"
      class="grid tx-table-row"
      [ngClass]="{
        'tx-table-row-active': selectedAutosave?.sessionId === a.sessionId
      }"
      (click)="onAutosaveSelected(a)"
      (dblclick)="onOpenInNewTabClicked(a)">
      <div class="g-col-5 ps-1 d-flex align-items-center gap-3">
        <i class="bi bi-file-earmark"></i>
        <div class="text-truncate" [title]="a.filename">
          {{ a.filename != null && a.filename !== '' ? a.filename : 'Untitled' }}
        </div>
      </div>
      <div class="g-col-4">
        {{ a.dtStamp != null ? (a.dtStamp | date : 'MM/dd/yyyy h:mm a') : '' }}
      </div>
      <div class="g-col-1">
        {{ a.initials }}
      </div>
      <div class="g-col-2">
        <div class="d-flex align-items-center justify-content-end gap-2 h-100">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="onOpenInNewTabClicked(a)"
            title="Recover document in new tab">
            <i class="bi bi-recycle"></i>
          </button>
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            (click)="onDeleteClicked(a)"
            title="Delete recovered document">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <form
    ngNoForm
    [action]="submitUrl"
    method="post"
    enctype="application/x-www-form-urlencoded"
    target="_blank"
    #openInNewTabForm>
    <input type="hidden" id="autosaveSessionId" name="autosaveSessionId" />
    <input type="hidden" id="extension" name="extension" />
    <input type="hidden" [id]="sessionId" [name]="sessionId" />
  </form>
</div>
